import {
  combineReducers,
  Store,
  ReducersMapObject
} from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { State } from './state';

import { createUIMiddleware } from './middleware/ui';
import { createEmbeddingMiddleware } from './middleware/embedding-api';
import { createProgressionMiddleware } from './middleware/progression';
import { currentProblemReducers } from './reducers/current-problem';
import { progressionReducers } from './reducers/progression';
import { uiReducer } from './reducers/ui';
import { skillBarReducer } from './reducers/skill-bar';

// Define the global state shape!
const reducers: ReducersMapObject = {
  // content: contentReducers,
  currentProblemState: currentProblemReducers,
  progression: progressionReducers,
  ui: uiReducer,
  skillBar: skillBarReducer
};

const middlewares = [
    createUIMiddleware,
    createEmbeddingMiddleware,
    createProgressionMiddleware
];

// Create THE store! FIXME
const store: Store<State> = configureStore(
  {
    reducer: combineReducers<State>(reducers),
    middleware: middlewares,
  }
);

export type ContentStore = Store<State>;
export type AppDispatch = ContentStore['dispatch'];
export default store;
